import { Card, CardContent, Typography, Box } from "@mui/material";
import { colors, radii, shadows, fonts } from "../../../theme/designTokens";

export default function DashboardCard({ title, children, minHeight, action }) {
  return (
    <Card
      sx={{
        borderRadius: radii.lg,
        boxShadow: shadows.card,
        border: `1px solid ${colors.line}`,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent
        sx={{
          minHeight,
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 1,
            mb: 1.5,
            pb: 1,
            borderBottom: `1px solid ${colors.line}`,
          }}
        >
          <Typography
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: 15,
              color: colors.ink,
            }}
          >
            {title}
          </Typography>
          {action}
        </Box>
        <Box sx={{ flex: 1 }}>{children}</Box>
      </CardContent>
    </Card>
  );
}
